// Vendors
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';

// Services
import { AuthState } from '@/store/features/auth/authSlice';
import { fetchContractDetailsStart } from '@/store/features/contractDetails/contractDetailSlice';
import { useAppDispatch, useAppSelector } from '@/hooks/storeHook';

// Assets
import infoIcon from '@/assets/icons/infoIcon.svg';

// Models
import { CustomerByContractRequest } from '@/api/models/BaseRequest';
import { ContractDetails } from '@/utils/types/contractDetails';

/**
 * Component: Customer Details
 * This component fetches and displays Customer details based on the contract ID from the URL.
 */

interface CustomerCardProps {
  handleContractListPopup: () => void;
  handleContractCustomerPopup: () => void;
}

const CustomerCard: React.FC<CustomerCardProps> = ({
  handleContractListPopup,
  handleContractCustomerPopup,
}) => {
  const dispatch = useAppDispatch();
  const { contractId, clientId } = useParams<{ contractId: string, clientId: string }>();

  const contractDetails = useAppSelector(
    (state: { contractDetails: { contractDetails: ContractDetails | null } }) =>
      state.contractDetails.contractDetails,
  );

  const user = useAppSelector((state: { auth: AuthState }) => state.auth.user);
  const isInternalUser = user?.apv_groups.includes('APV AppRole_AssurTrack Internal');

  useEffect(() => {
    if (contractId) {
      var request: CustomerByContractRequest = {
        contractId: contractId,
        clientId : clientId,
        keyword: '',
        pageNo: 0,
        pageSize: 0,
      };
      dispatch(fetchContractDetailsStart(request));
    }
  }, [dispatch, contractId]);

  return (
    <div className="contract-info">
      <div className="info-wrap">
        <Typography className="company-name">{contractDetails?.customerName ?? ''}</Typography>
        <img
          src={infoIcon}
          alt="info-icon"
          className="info-icon"
          onClick={handleContractCustomerPopup}
        />
      </div>

      <Typography className="info">
        <span>Customer #:</span> {contractDetails?.customerId ?? ''}
        {isInternalUser && (
          <>
            | <span>Class Code:</span> {contractDetails?.classCode ?? ''}
          </>
        )}
      </Typography>

      <Typography className="link" onClick={handleContractListPopup}>
        See all contracts
      </Typography>
    </div>
  );
};

export default CustomerCard;
